<template>
    <b-modal
        id="modal-form-group"
        ref="ModalFormGroup"
        :title="$t('addGroup')"
        size="lg"
        static
        centered
        hide-footer
        @show="resetData()"
        @hidden="resetData()"
    >
        <FormGroup ref="FormGroup" class="mb-0" />
    </b-modal>
</template>



<script>
    import FormGroup from '@/views/producer/product-groups/_id/parts/Form.vue';

    export default {
        name: 'ModalFormGroup',
        components: {
            FormGroup,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestGroups: this.$req('producerProductGroups/groups'),
                item: null,
            };
        },
        computed: {
            id() {
                return this.item?.id;
            },
        },
        methods: {
            fetchData() {
                this.parentComponent.fetchData();
            },
            onInit(item) {
                this.item = item;
            },
            resetData() {
                this.item = null;
                this.$refs.FormGroup?.resetData();
            },
        },
        mounted() {
            this.$root.$on('modal-form-group', this.onInit);
        },
        beforeDestroy() {
            this.$root.$off('modal-form-group', this.onInit);
        },
    };
</script>
